import { JeTagType } from "src/utils/constants";

export interface SetUpTagJournalEntryModalState {
    jeTagDescription: string;
    originalJETagDescription: string;
    beatCliRole: JeTagType;
    associatedBaseJE: string;
    baseJEOptions: {label: string, value: string}[];
    shouldFetchJeTags: boolean;
    shouldUnTagJeTags: boolean;
}

export const initialState: SetUpTagJournalEntryModalState = {
    jeTagDescription: '',
    originalJETagDescription: '',
    beatCliRole: JeTagType.BASE,
    associatedBaseJE: '',
    baseJEOptions: [],
    shouldFetchJeTags: false,
    shouldUnTagJeTags: false
};

